import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import {
  SILENT_VOICE_ID,
  HINDI_INDIAN_VOICE_ID,
} from '../../hooks/useSpeechSynthesis';
import './VoiceSelector.css';

const VoiceSelector = ({ selectedVoice, onVoiceChange }) => {
  const { t } = useLanguage();
  const silentVoice = { name: SILENT_VOICE_ID, lang: 'silent' };
  const hindiIndianVoice = { name: HINDI_INDIAN_VOICE_ID, lang: 'hi-IN' };
  const selectedVoiceName = selectedVoice?.name === SILENT_VOICE_ID ? SILENT_VOICE_ID : HINDI_INDIAN_VOICE_ID;

  const handleSelectChange = (event) => {
    const option = event.target.value;

    if (option === SILENT_VOICE_ID) {
      onVoiceChange(silentVoice);
      return;
    }

    if (option === HINDI_INDIAN_VOICE_ID) {
      onVoiceChange(hindiIndianVoice);
    }
  };

  return (
    <div className="voice-selector">
      <label htmlFor="voice-select">{t('bhaktiJaapaPage.voiceSelector.selectVoice')}</label>
      <select
        id="voice-select"
        value={selectedVoiceName}
        onChange={handleSelectChange}
      >
        <option value={SILENT_VOICE_ID}>
          {t('bhaktiJaapaPage.voiceSelector.silent')}
        </option>
        <option value={HINDI_INDIAN_VOICE_ID}>
          {t('bhaktiJaapaPage.voiceSelector.hindiIndian')}
        </option>
      </select>
    </div>
  );
};

export default VoiceSelector;
